import React from 'react'
import Flex from 'typescript-styled-flex'
import InputSquare from './InputSquare'
import { ICheckboxProps } from './index'

function SquareCheckbox(C: React.ComponentType<any>) {
  return function({
    name,
    onClick,
    onChange,
    value,
    onKeyDown,
    onFocus,
    readonly,
    disabled = false,
    size = 1,
    onBlur,
    className,
    inputRef,
  }: ICheckboxProps) {
    function onchange(e: React.SyntheticEvent<any>) {
      e.stopPropagation()
      onChange(e)
    }

    function onclick(e) {
      e.stopPropagation()
    }

    return (
      <Flex
        style={{ position: 'relative', zIndex: 0 }}
        onClick={!disabled && onClick}
      >
        <InputSquare
          ref={inputRef}
          name={name}
          disabled={disabled}
          type="checkbox"
          onClick={!disabled && onclick}
          onChange={!disabled && onchange}
          readOnly={readonly}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
          size={size}
          value={value}
          checked={value}
          className={className}
          data-cy={className}
        />
        <C disabled={disabled} onFocus={onFocus} onBlur={onBlur} size={size} />
      </Flex>
    )
  }
}

export default SquareCheckbox
